
import React from 'react';
import ResponsiveContainer from 'recharts/lib/component/ResponsiveContainer';
import LineChart from 'recharts/lib/chart/LineChart';
import Line from 'recharts/lib/cartesian/Line';
import XAxis from 'recharts/lib/cartesian/XAxis';
import YAxis from 'recharts/lib/cartesian/YAxis';
import CartesianGrid from 'recharts/lib/cartesian/CartesianGrid';
import Tooltip from 'recharts/lib/component/Tooltip';
import Legend from 'recharts/lib/component/Legend';

export function MeasurementDetailChart(props) {

    const { data } = props;
    return (
        <div style={{ marginTop: 48, marginLeft: 32, marginRight: 32 }}>
            <ResponsiveContainer width="99%" height={320}>

                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="timestamp" />
                    <YAxis yAxisId="left" label={{ value: 'Temperatur in ˚C', angle: -90, position: 'insideLeft' }} />
                    <YAxis yAxisId="right" orientation="right" label={{ value: 'Wassermenge in ml', angle: 90, position: 'insideRight' }} />
                    <Tooltip />
                    <Legend />
                    <Line yAxisId="left" type="monotone" dataKey="c" stroke="#EE7202" />
                    <Line yAxisId="right" type="monotone" dataKey="ml" stroke="#00254C" />

                </LineChart>
                </ResponsiveContainer>

                <ResponsiveContainer width="99%" height={320}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="timestamp" />
                    <YAxis yAxisId="left" label={{ value: 'Abstand in mm', angle: -90, position: 'insideLeft' }} />
                    <Tooltip />
                    <Legend />
                    <Line yAxisId="left" type="monotone" dataKey="mm" stroke="#EE7202" />

                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
